import { QuoteModel } from '../models/quote.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Estate, EarticleType } from '../utils/enum.util';
import { ArticleModel } from '../models/article.model';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable()
export class QuoteService {

    private antiRebound = 300;
    private timestamp   = 0;

    constructor(public apiService: ApiService, private location: Location, private router: Router) {

    }

    loadCustomer(privateId: string, quote: QuoteModel) {
        this.apiService.get('client', 'privateId=' + privateId).subscribe(res=> {
            quote.infoClientName   = res.data.lastName + ' ' + res.data.firstName;
            quote.infoClientAdress = res.data.adress.name + '\n' + res.data.adress.code + ' ' + res.data.adress.city + '\n' + res.data.adress.country;
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    generateData(quote: QuoteModel) {
        let articles: any = [];
        let article: any  = {};

        quote.articles.forEach((a)=> {
            article = {
                'type'    : a.getTypeText(),
                'price'   : a.price.toString(),
                'free'    : a.free.toString(),
                'quantity': a.quantity.toString(),
                'about'   : a.about
            };

            if (a.getTypeText() == 'bike') {
                article.about        = null;
                article.bike         = {};
                article.bike.id      = a.bike.id;
                article.bike.brand   = a.bike.brand;
                article.bike.model   = a.bike.model;
                article.bike.size    = a.bike.size;
                article.bike.numCad  = a.bike.numCad;
                article.bike.comment = a.bike.comment;
            }

            articles.push(article);
        });

        let data: any = {
            quotePublicId      : quote.publicId,
            where             : quote.where,
            when              : quote.whenYear.toString() + '-' +
                ('0' + (((quote.whenMonth)).toString())).slice(-2) + '-' +
                ('0' + (quote.whenDay.toString())).slice(-2),
            comment           : quote.info,
            infoClientName    : quote.infoClientName,
            infoClientAdress  : quote.infoClientAdress,
            nbHourWorkForce   : '0',
            priceHourWorkForce: quote.priceHourWorkForce.toString(),
            shippingPrice     : '0',
            discount          : '0',
            magasin           : quote.magasin,
            articles          : articles,
            useless           : quote.useless.toString()
        };

        if (quote.nbHourWorkForce)
            data.nbHourWorkForce = quote.nbHourWorkForce.toString();

        if (quote.shippingPrice)
            data.shippingPrice = quote.shippingPrice.toString();

        if (quote.discount)
            data.discount = quote.discount.toString();

        if (quote.privateId) {
            data.privateId = quote.privateId;
        } else {
            data.clientPrivateId = quote.clientPrivateId;
        }

        return data;
    }

    load(quotePrivateId: string, quote: QuoteModel) {
        this.apiService.get('quote', 'privateId=' + quotePrivateId).subscribe(res=> {
            quote.privateId          = res.data._id;
            quote.archive            = res.data.archive;
            quote.publicId           = res.data.quotePublicId;
            quote.clientPrivateId    = res.data.clientPrivateId;
            quote.info               = res.data.comment;
            quote.discount           = res.data.discount;
            quote.infoClientAdress   = res.data.infoClientAdress;
            quote.infoClientName     = res.data.infoClientName;
            quote.nbHourWorkForce    = res.data.nbHourWorkForce;
            quote.priceHourWorkForce = res.data.priceHourWorkForce;
            quote.shippingPrice      = res.data.shippingPrice;
            quote.useless            = res.data.useless;
            quote.where              = res.data.where;
            quote.magasin            = res.data.magasin;
            quote.setWhen(res.data.when);
            res.data.articles.forEach((a)=> {
                let article      = new ArticleModel(quote);
                article.about    = a.about;
                article.free     = a.free;
                article.price    = a.price;
                article.quantity = a.quantity;
                if (a.type == 'service')
                    article.type = EarticleType.Service;
                if (a.type == 'accessory')
                    article.type = EarticleType.Accessory;
                if (a.type == 'bike') {
                    article.type = EarticleType.Bike;
                    article.bike = a.bike;
                }
                quote.articles.push(article);
            });

            if (quote.nbHourWorkForce == 0)
                quote.nbHourWorkForce = null;

            if (quote.shippingPrice == 0)
                quote.shippingPrice = null;

            if (quote.discount == 0)
                quote.discount = null;

            quote.calculateValue();
            quote.validateArticles();
            quote.validate();
            quote.state = Estate.Save;
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    duplicate(quotePrivateId: string, quote: QuoteModel, redirect: boolean = false) {
        this.apiService.get('quote', 'privateId=' + quotePrivateId).subscribe(res=> {
            quote.privateId          = null;
            quote.archive            = res.data.archive;
            quote.publicId           = res.data.quotePublicId;
            quote.clientPrivateId    = res.data.clientPrivateId;
            quote.info               = res.data.comment;
            quote.discount           = res.data.discount;
            quote.infoClientAdress   = res.data.infoClientAdress;
            quote.infoClientName     = res.data.infoClientName;
            quote.nbHourWorkForce    = res.data.nbHourWorkForce;
            quote.priceHourWorkForce = res.data.priceHourWorkForce;
            quote.shippingPrice      = res.data.shippingPrice;
            quote.useless            = true;
            quote.where              = res.data.where;
            quote.magasin            = res.data.magasin;
            quote.setWhen(res.data.when);
            if (quote.articles.length > 0)
                quote.articles = [];
            res.data.articles.forEach((a)=> {
                let article      = new ArticleModel(quote);
                article.about    = a.about;
                article.free     = a.free;
                article.price    = a.price;
                article.quantity = a.quantity;
                if (a.type == 'service')
                    article.type = EarticleType.Service;
                if (a.type == 'accessory')
                    article.type = EarticleType.Accessory;
                if (a.type == 'bike') {
                    article.type = EarticleType.Bike;
                    article.bike = a.bike;
                }
                quote.articles.push(article);
            });
            quote.calculateValue();
            quote.validateArticles();
            quote.validate();
            quote.state = Estate.Save;
            this.create(quote, redirect);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    delete(quote: QuoteModel, action: string) {
        let data;

        //patch pour désarchiver
        if (action == 'delete')
            data = {privateId: quote.privateId, confirm: 'true'};
        if (action == 'archive')
            data = {privateId: quote.privateId, confirm: 'false'};
        if (action == 'unarchive')
            data = {privateId: quote.privateId, unarchive: 'true'};

        this.apiService.delete('quote', data).subscribe((_res)=> {
            if (action == 'delete') {
                this.router.navigateByUrl('/customer/' + quote.clientPrivateId);
            } else {
                quote.archive = !quote.archive;
            }
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    update(quote: QuoteModel) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('quote', this.generateData(quote)).subscribe((_res)=> {
                    quote.state = Estate.Save;
                }, (_err)=> {
                    this.apiService.error(_err);
                    quote.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    create(quote: QuoteModel, redirect: boolean = false) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.post('quote', this.generateData(quote)).subscribe(res=> {
                    quote.state     = Estate.Save;
                    quote.privateId = res.data.privateId;
                    this.location.replaceState('/quote/' + quote.clientPrivateId + '/' + quote.privateId);
                    if (redirect) {
                        this.router.navigate(['quote', quote.clientPrivateId, quote.privateId]);
                    }
                }, (_err)=> {
                    this.apiService.error(_err);
                    quote.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/quote.service.ts